import React from 'react';
import {MicrolessonListItem} from '../../../../data/models/Microlessons/MicrolessonListItem';
import {logoTextWhite} from '../../../../assets/images';
import MicrolessonsOptions from './MicrolessonsOptions';
import Tooltip from '../../../../uiToolkit/Tooltip';
import {microlessonsListText} from '../microlessonsListText';

interface Props {
  lesson: MicrolessonListItem;
  onEditLesson: (id: string) => void;
  onPreviewLesson: (id: string) => void;
  onEditLessonInfo: (lessonId: string) => void;
  onEditLessonVideo: (id: string) => void;
  onDelete: (id: string) => void;
}

const MicrolessonListCard = React.memo(
  ({
    lesson,
    onEditLesson,
    onPreviewLesson,
    onEditLessonInfo,
    onEditLessonVideo,
    onDelete,
  }: Props) => {
    return (
      <div className="MicrolessonCardContainer">
        <div className="MicrolessonCard">
          <div className="ImageContainer">
            {lesson.poster ? (
              <img src={lesson.poster} />
            ) : (
              <img src={logoTextWhite} className="PlaceholderLogo" />
            )}
          </div>
          <div className="LessonTitleContainer">
            {lesson.inProgress ? (
              <p
                style={{
                  textAlign: 'center',
                }}>
                {microlessonsListText.generating}
              </p>
            ) : (
              <>
                <Tooltip tooltipText={lesson.title}>
                  <p>{lesson.title}</p>
                </Tooltip>
                <Tooltip tooltipText={lesson.description}>
                  <span>{lesson.description}</span>
                </Tooltip>
              </>
            )}
          </div>
          {!lesson.inProgress && (
            <div className="LessonOptionsPosition">
              <MicrolessonsOptions
                lessonId={lesson.id}
                onEditLesson={onEditLesson}
                onPreviewLesson={onPreviewLesson}
                onEditLessonInfo={onEditLessonInfo}
                onEditLessonVideo={onEditLessonVideo}
                onDelete={onDelete}
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default MicrolessonListCard;
